// Shared pagination: connected Bootstrap-style controls, using the existing POS theme.
export function paginationPages(page, count) {
  if (count <= 7) return Array.from({ length: count }, (_, index) => index + 1);
  const pages = [1];
  const start = Math.max(2, Math.min(page - 1, count - 3));
  const end = Math.min(count - 1, Math.max(page + 1, 4));
  if (start > 2) pages.push('before');
  for (let value = start; value <= end; value++) pages.push(value);
  if (end < count - 1) pages.push('after');
  pages.push(count);
  return pages;
}

export default function Pagination({ page, pageSize, total, onPageChange, onPageSizeChange, loading = false, label = 'Navigasi halaman', pageSizeOptions = [10, 25, 50, 100], allowAll = true, children }) {
  const all = pageSize === 'all';
  const count = all ? 1 : Math.max(1, Math.ceil(total / pageSize));
  const current = Math.max(1, Math.min(page, count));
  const buttonClass = 'h-9 min-w-9 px-2 border border-ui-line -ml-px bg-ui-card text-brand-readable hover:bg-ui-soft focus-visible:z-10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand disabled:opacity-40 disabled:cursor-not-allowed';
  return <div className="flex w-full min-w-0 flex-wrap items-center justify-between gap-3" data-testid="pagination">
    <div data-slot="page-size-search" className={`flex min-w-0 flex-1 flex-wrap items-center gap-2 ${children ? 'basis-72' : ''}`}>
    <label className="flex shrink-0 items-center gap-2 text-xs text-ui-muted">Tampilkan
      <select aria-label="Jumlah baris per halaman" className="h-9 rounded border border-ui-line bg-ui-card text-ui-text px-2" value={pageSize} onChange={e => onPageSizeChange(e.target.value === 'all' ? 'all' : Number(e.target.value))}>
        {pageSizeOptions.map(size => <option key={size} value={size}>{size} baris</option>)}
        {allowAll && <option value="all">Lihat semua</option>}
      </select>
    </label>
    {children}
    </div>
    {!all && <nav aria-label={label} className="max-w-full overflow-x-auto"><ul className="inline-flex list-none p-0 m-0">
      <li><button type="button" className={`${buttonClass} rounded-l-lg ml-0`} aria-label="Halaman sebelumnya" disabled={loading || current <= 1} onClick={() => onPageChange(current - 1)}>«</button></li>
      {paginationPages(current, count).map(value => <li key={value}>{typeof value === 'number'
        ? <button type="button" aria-label={`Halaman ${value}`} aria-current={value === current ? 'page' : undefined} disabled={loading || value === current} onClick={() => onPageChange(value)} className={`${buttonClass} ${value === current ? '!bg-brand-soft !text-brand-readable font-bold !opacity-100' : ''}`}>{value}</button>
        : <span className={`${buttonClass} inline-flex items-center text-ui-muted`} aria-hidden="true">…</span>}</li>)}
      <li><button type="button" className={`${buttonClass} rounded-r-lg`} aria-label="Halaman berikutnya" disabled={loading || current >= count} onClick={() => onPageChange(current + 1)}>»</button></li>
    </ul></nav>}
  </div>;
}
